import service from '@/utils/request';

// 获取用户信息
export async function getUserInfo(data, customConf = { loading: true }) {
    const dataOrg = await service.post('/infc/wx/getWXUserInfo', data, { custom: customConf });
    return {
        token: dataOrg.unionid || dataOrg.openid,
        nickname: dataOrg.nickname,
        avatarUrl: dataOrg.headimgurl,
        openID: dataOrg.openid,
        unionID: dataOrg.unionid,
        subscribeIng: dataOrg.subscribe,
    };
}

// 售后登录发送验证码
export function maintenanceLoginSendCode(data, customConf = { loading: true }) {
    return service.post('/infc/wxUser/sendPhoneCode', data, { custom: customConf });
}

// 售后手机登录
export function maintenanceLogin(data, customConf = { loading: true }) {
    return service.post('/infc/wxUser/wxUserPhoneLogin', data, { custom: customConf });
}
